export default __webpack_public_path__ + "static/media/13-BB-(3-2).226267e1.jpg";